/**
 * Sticky stepper footer — renders the right action buttons per step (1/2/3).
 * Kept as a tiny presentational component so the modal composer stays thin.
 */
import React from 'react';
import { Button } from '../ui/button';
import { ArrowRight, ArrowLeft } from 'iconoir-react';

export default function StepperFooter({
  step,
  loading,
  selectedTemplateCount,
  selectedEventCount,
  selectedTaskCount,
  canSubmit,
  onCancel,
  onBack,
  onSkipTemplate,
  onGoToCustomize,
  onCreate,
}) {
  const hasTemplates = selectedTemplateCount > 0;
  return (
    <div className="flex-shrink-0 pt-4 border-t border-border mt-4">
      {step === 1 && (
        <div className="flex gap-3">
          <Button type="button" onClick={onCancel} className="btn-secondary flex-1">
            Cancel
          </Button>
          <Button
            type="submit"
            form="wedding-form"
            disabled={!canSubmit}
            className="btn-primary flex-1 flex items-center justify-center gap-2"
            data-testid="next-to-templates-btn"
          >
            Next <ArrowRight className="w-4 h-4" />
          </Button>
        </div>
      )}

      {step === 2 && (
        <div className="flex gap-3">
          <Button type="button" onClick={onBack} className="btn-secondary flex items-center justify-center gap-2">
            <ArrowLeft className="w-4 h-4" /> Back
          </Button>
          <Button
            type="button"
            onClick={onSkipTemplate}
            disabled={loading}
            className="btn-secondary flex-1"
            data-testid="skip-template-btn"
          >
            {loading ? 'Creating...' : 'Skip - No Template'}
          </Button>
          {hasTemplates && (
            <Button
              type="button"
              onClick={onGoToCustomize}
              className="btn-primary flex-1 flex items-center justify-center gap-2"
              data-testid="customize-template-btn"
            >
              {selectedTemplateCount > 1 ? `Customize Fusion (${selectedTemplateCount})` : 'Customize'}
              <ArrowRight className="w-4 h-4" />
            </Button>
          )}
        </div>
      )}

      {step === 3 && (
        <div className="flex gap-3">
          <Button type="button" onClick={onBack} className="btn-secondary flex items-center justify-center gap-2">
            <ArrowLeft className="w-4 h-4" /> Back
          </Button>
          <Button
            type="button"
            onClick={onCreate}
            disabled={loading || selectedEventCount === 0}
            className="btn-primary flex-1"
            data-testid="create-wedding-btn"
          >
            {loading ? 'Creating...' : `Create with ${selectedEventCount} Events & ${selectedTaskCount} Tasks`}
          </Button>
        </div>
      )}
    </div>
  );
}
